import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// material-ui
import { makeStyles } from '@mui/styles';
import { Menu, Box, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Logout from "@mui/icons-material/Logout";
// import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';

// project imports
import LogoSection from '../LogoSection';
import { Link as RouterLink } from 'react-router-dom';
import configData from '../../config';
import '../../assets/scss/style.css';
import Logo from '../../ui-component/Logo';
import { ButtonStyles } from '../../utils/general';
import { useTheme } from "@mui/styles";

// assets
// import { IconMenu2 } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
    },
    iconButton: {
        backgroundColor: '#216bfd',
        color: 'white',
        '&:hover': {
            background: theme.palette.secondary.dark,
        },
      },
    // boxContainer: {
    //     width: '200px',
    //     display: 'flex',
    //     [theme.breakpoints.down('md')]: {
    //         width: 'auto'
    //     }
    // }, 
    disp : {
        bgcolor:'primary.light'
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();
    const theme = useTheme();

    const [menuOpen, setMenuOpen] = useState(false);

    function handleMenuClose(){
        setMenuOpen(null);
    }

    return (
        <React.Fragment>
            {/* logo & toggler button */}
            {/* <div className={classes.boxContainer}> */}
                <Box component="span" sx={{ flexGrow: 1, margin: 0.5 }}>
                    <RouterLink to={'/dashboard'} style={{textDecoration: "none"}}>
                        <Logo />
                    </RouterLink>
                </Box>
                {/* <ButtonBase sx={{ borderRadius: '1px',  overflow: 'hidden' }}>
                    <Avatar variant="rounded" className={classes.headerAvatar} onClick={handleLeftDrawerToggle} color="inherit">
                    <IconButton className={classes.iconButton} >
                    <IconMenu2 />
                </IconButton>
                        
                    </Avatar>
                </ButtonBase> */}
            {/* </div> */}
            {/* <Typography variant="h1" component="div" sx={{ fontSize: '24px',flexGrow: 1, textAlign: 'left', p:2, minWidth: 50, fontFamily: 'cursive', color:'#1a8cff' }}>
                Movie Project
            </Typography> */}
            <div className={classes.root} >
                {/* <RouterLink to={'/logout'}>
                <Button variant="contained"
                    style={ButtonStyles(theme)} size="small">Logout</Button>
                </RouterLink> */}
                <AccountCircleIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff", width: "35px", height: "35px" }} onClick={(e) => setMenuOpen(e.currentTarget)}/>
                <Menu
                  anchorEl={menuOpen}
                  open={Boolean(menuOpen)}
                  onClose={handleMenuClose}
                  PaperProps={{
                    style: {
                      backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark, 
                    },
                  }}
                >
                    <RouterLink to={'/organization_profile_list'} style={{ textDecoration: "none", color: "grey" }}>
                        <MenuItem onClick={handleMenuClose}
                            sx={{
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              '&:hover': {
                                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                                transform: "translateX(4px)",
                              }
                            }}
                        >
                            <CorporateFareIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff" }}/>
                            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Organizations</span>
                        </MenuItem>
                    </RouterLink>
                    {/* <RouterLink to={'/user_profile_list'} style={{ textDecoration: "none", color: "grey" }}>
                        <MenuItem onClick={handleMenuClose}
                            sx={{
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              '&:hover': {
                                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                                transform: "translateX(4px)",
                              }
                            }}
                        >
                        </MenuItem>
                    </RouterLink> */}
                    <RouterLink to={'/logout'} style={{ textDecoration: "none", color: "grey" }}>
                        <MenuItem onClick={handleMenuClose}
                            sx={{
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              '&:hover': {
                                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                                transform: "translateX(4px)",
                              }
                            }}
                        >
                            <Logout sx={{ color: theme.palette.themeMode == 'dark' ? "#fff" : "#000000ff" }}/>
                            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Logout</span>
                        </MenuItem>
                    </RouterLink>
                </Menu>
            </div>
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
